import React, { useState, useEffect } from "react";
import LoadingSpinner from "../components/common/LoadingSpinner";
import InvoiceBreakdownTable from "../components/staff/invoice/InvoiceBreakdownTable";
import { useParams } from "react-router-dom";
import { getInvoiceById } from "../api/invoiceAPI";
import { useTheme } from "../context/ThemeContext";
import { PageContainer, PageHeading } from "../components/ui";

const MemberInvoice: React.FC = () => {
  const { isDarkMode } = useTheme();
  const { invoiceId, clubid } = useParams();
  // Nothing to load without an invoice id: the address /member/invoice (with
  // no id) used to show the spinner forever.
  const [loading, setLoading] = useState(!!invoiceId);
  const [error, setError] = useState<string | null>(null);
  const [invoice, setInvoice] = useState<any>(null);
  // HELPER
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    const loadInvoice = async () => {
      try {
        setLoading(true);
        const response = await getInvoiceById(token, invoiceId);

        if (response?.success) {
          setInvoice(response.data);
        } else {
          setError(response?.error || "Failed to fetch invoice");
        }
      } catch (err: any) {
        setError(err.message || "Unexpected error");
      } finally {
        setLoading(false);
      }
    };

    if (invoiceId) {
      loadInvoice();
    }
  }, [invoiceId, token]);

  if (!invoiceId) {
    return (
      <PageContainer>
        <PageHeading title="Invoice" />
        <div className={`text-center py-12 ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>
          <p className="text-lg font-medium">No invoice was chosen.</p>
          <p className="mt-2">
            Open an invoice from your{" "}
            <a
              className="underline text-[var(--cc-link)]"
              href={clubid ? `/${clubid}/member/view-billing` : "/"}
            >
              Billing page
            </a>
            .
          </p>
        </div>
      </PageContainer>
    );
  }

  if (loading) {
    return (
      <PageContainer className="flex justify-center items-center">
        <LoadingSpinner size="large" />
      </PageContainer>
    );
  }
  if (error)
    return (
      <PageContainer>
        <PageHeading title="Invoice" />
        <p role="alert" className="text-red-600">{error}</p>
      </PageContainer>
    );

  return (
    <PageContainer>
      <PageHeading title="Invoice" />
      <InvoiceBreakdownTable invoiceData={invoice} />
    </PageContainer>
  );
};

export default MemberInvoice;
